function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M24 0H0v24h24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8415",
  fillRule: "nonzero",
  d: "M22 2v20H2V2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10 8v2H8v4h2v2H6V8h4zm8 0v8h-4v-2h2v-4h-2V8h4z"
}));

function SvgQFillInTheBlankCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgQFillInTheBlankCompletedIcon;